// extracted by mini-css-extract-plugin
module.exports = {"HeaderHeight":"60px","container":"_3vwE-","main":"_1eA2z"};